if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.bundle = this.closest('.custom-main-product-info-wrapper') ?? null;
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Aantal-bescherming (Elusive, 5 okt 2026): zit deze variant al in de winkelwagen en vraagt de
        // klant niet uitdrukkelijk om meer (aantal 1, geen bundel), dan niet ophogen maar de lade openen.
        // Reden: 13 van 124 verlaten checkouts met een hoofdtoestel bevatten 2 tot 7 exemplaren door
        // herhaald klikken; bij orders komt dat vrijwel nooit voor.
        const bundleMode = this.bundle != null && this.bundle.querySelector('#new-bundle-product-check')?.checked == true;
        const qtyInput = this.form.querySelector('[name="quantity"]');
        const requestedQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        const cartDrawer = this.cart && typeof this.cart.open === 'function' ? this.cart : null;
        if (!bundleMode && requestedQty <= 1 && cartDrawer && !this.dataset.skipDuplicateGuard) {
          const variantId = String(this.variantIdInput.value);
          this.submitButton.setAttribute('aria-disabled', true);
          fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
            .then((response) => response.json())
            .then((cart) => {
              const alreadyInCart = (cart.items || []).some((item) => String(item.variant_id) === variantId);
              this.submitButton.removeAttribute('aria-disabled');
              if (alreadyInCart) {
                cartDrawer.open(this.submitButton);
                return;
              }
              this.performAdd();
            })
            .catch(() => {
              this.submitButton.removeAttribute('aria-disabled');
              this.performAdd();
            });
          return;
        }
        this.performAdd();
      }

      performAdd() {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        if(this.bundle != null && this.bundle.querySelector("#new-bundle-product-check")?.checked == true){
          let arr = [];
          let $this = this;
          this.bundle.querySelectorAll(".new-bundle-product-item-active").forEach((item) => {
            let vid = item.getAttribute("data-id");
            arr.push({'id': vid, 'quantity': 1});
          })
          let fd = {
          'items': arr
          };
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(fd)
          })
          .then(response => {
            return response.json();
          })
          .then(function(res){
            if(res.status){
              console.log("error");
            }
            else{
              fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    publish(PUB_SUB_EVENTS.cartError, {
                      source: 'product-form',
                      productVariantId: formData.get('id'),
                      errors: response.errors || response.description,
                      message: response.message,
                    });
                    $this.handleErrorMessage(response.description);

                    const soldOutMessage = $this.submitButton.querySelector('.sold-out-message');
                    if (!soldOutMessage) return;
                    $this.submitButton.setAttribute('aria-disabled', true);
                    $this.submitButtonText.classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                    $this.error = true;
                    return;
                  } else if (!$this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                  }

                  if (!$this.error)
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: 'product-form',
                      productVariantId: formData.get('id'),
                      cartData: response,
                    });
                  $this.error = false;
                  const quickAddModal = $this.closest('quick-add-modal');
                  if (quickAddModal) {
                    document.body.addEventListener(
                      'modalClosed',
                      () => {
                        setTimeout(() => {
                          $this.cart.renderContents(response);
                        });
                      },
                      { once: true }
                    );
                    quickAddModal.hide(true);
                  } else {
                    $this.cart.renderContents(response);
                  }
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  $this.submitButton.classList.remove('loading');
                  if ($this.cart && $this.cart.classList.contains('is-empty')) $this.cart.classList.remove('is-empty');
                  if (!$this.error) $this.submitButton.removeAttribute('aria-disabled');
                  $this.querySelector('.loading__spinner').classList.add('hidden');
                });
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          })
        }
        else{
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          let vid = this.form.querySelector('[name="id"]').value;
          console.log(vid);
          let price = document.querySelector(`.custom-master-ids li[data-id="${vid}"]`).getAttribute("data-price");
          this.submitButtonText.innerHTML = `<svg style="width: 13px; color: white; height: 13px; margin-right: 10px; margin-top: -3px;" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 25 25"><path fill="white" d="M5.058 23a2 2 0 104.001-.001A2 2 0 005.058 23zm12.079 0c0 1.104.896 2 2 2s1.942-.896 1.942-2-.838-2-1.942-2-2 .896-2 2zM0 1a1 1 0 001 1h1.078l.894 3.341L5.058 13c0 .072.034.134.042.204l-1.018 4.58A.997.997 0 005.058 19h16.71a1 1 0 000-2H6.306l.458-2.061c.1.017.19.061.294.061h12.31c1.104 0 1.712-.218 2.244-1.5l3.248-6.964C25.423 4.75 24.186 4 23.079 4H5.058c-.157 0-.292.054-.438.088L3.844.772A1 1 0 002.87 0H1a1 1 0 00-1 1zm5.098 5H22.93l-3.192 6.798c-.038.086-.07.147-.094.19-.067.006-.113.012-.277.012H7.058v-.198l-.038-.195L5.098 6z"></path></svg> ${window.variantStrings.addToCart} ${price}`;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
